import React from 'react'

// material-ui
import Typography from '@mui/material/Typography'

// shared components
import Loading from 'components/atoms/Loading'
import RegistrationStep from 'components/register/shared/RegistrationStep'
import Form from 'components/account/PickupPeople/Form'

const EditPickupPerson = props => {
  const { queryLoading, mutationLoading, form } = props

  return (
    <RegistrationStep>
      <Typography pb={4} variant='h2' align='center'>
        Edit Pick-up Person
      </Typography>

      {!form || queryLoading ? (
        <Loading />
      ) : (
        <Form
          buttonText={mutationLoading ? 'Saving…' : 'Save'}
          editMode
          {...props}
        />
      )}
    </RegistrationStep>
  )
}

export default EditPickupPerson
